<template>
  <footer
    class="mt-auto border-t border-gray-200 bg-white dark:bg-gray-800 dark:border-gray-700/50"
  >
    <div
      class="w-full p-4 flex items-center justify-between text-sm text-gray-500 dark:text-gray-400"
    >
      <span>{{ release }}</span>
      <span>
        Crafted with
        <PhHeart
          color="#ef4444"
          class="inline"
          weight="fill"
          size="14"
        ></PhHeart>
        by
        <a
          class="font-semibold text-gray-600 dark:text-gray-300"
          href="https://synergitech.co.uk/"
          target="_blank"
        >
          Synergi Tech Ltd
        </a>
      </span>
    </div>
  </footer>
</template>

<script setup>
import { PhHeart } from "@phosphor-icons/vue";

const props = defineProps({
  release: {
    type: String,
    default: "",
  },
});
</script>
